import { useEffect, useCallback } from "react";

//From webdevsimplified's blog, modified to work better for our needs.

function useDebounceEffect(effect, callbackDeps, useEffectDeps, delay = 250) {
  const callback = useCallback(effect, callbackDeps);

  useEffect(() => {
    const timeout = setTimeout(callback, delay);
    return () => clearTimeout(timeout);
  }, [
    // callback, //don't want to call the effect every time the function itself changes.
    ...useEffectDeps,
    delay,
  ]);
}

export default useDebounceEffect;
